import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PAGES_URLS } from '../constants';

export const noAuthGuard: CanActivateFn = () => {
  const accessToken = localStorage.getItem('accessToken');

  if (accessToken) {
    const router = inject(Router);
    void router.navigate([PAGES_URLS.HotelReservations]);
    return false;
  }

  return true;
};
